(function ($) {
	'use strict';

	$(document).ready(function () {
		// Initialize selected class for any pre-selected radios
		$('.variation-radios input[type="radio"]:checked').each(function () {
			$(this)
				.closest('.variation-radio-item')
				.addClass('selected-variation');
		});
	});

	$(document).on('change', '.variation-radios input', function () {
		const name = $(this).attr('name');
		const value = $(this).val();

		// Update the corresponding select element
		$(`select[name = "${name}"]`).val(value).trigger('change');

		// Remove the selected class from all variation-radio-item elements
		$(this)
			.closest('.variation-radios')
			.find('.variation-radio-item')
			.removeClass('selected-variation');

		// Add the selected class to the wrapper of the selected radio button
		$(this).closest('.variation-radio-item').addClass('selected-variation');
	});

	// Enable selecting variation by clicking on the variation-radio-item
	$(document).on('click', '.variation-radio-item', function () {
		const radioInput = $(this).find('input[type="radio"]');
		if (!radioInput.prop('disabled')) {
			radioInput.prop('checked', true).trigger('change');
		}
	});

	// When variation values are updated (e.g., when product attributes change)
	$(document).on('woocommerce_update_variation_values', () => {
		$('.variation-radios input').each(function () {
			const name = $(this).attr('name');
			const value = $(this).val();

			const isDisabled = $(
				`select[name = "${name}"] option[value = "${value}"]`
			).is(':disabled');
			$(this).prop('disabled', isDisabled);

			const wrapper = $(this).closest('.variation-radio-item');
			wrapper.toggleClass('disabled-variation', isDisabled);
		});
	});

	/**
	 * Initialize variation selections - handles both pre-selected and auto-selection
	 */
	function initializeVariationSelections() {
		$('.variation-radios').each(function () {
			const alreadySelected = $(this).find('input[type="radio"]:checked');

			if (alreadySelected.length === 0) {
				// No pre-selected items, select first available
				const firstAvailableRadio = $(this)
					.find('input[type="radio"]:not(:disabled)')
					.first();

				if (firstAvailableRadio.length) {
					firstAvailableRadio.prop('checked', true);

					// Update the select dropdown and notify WooCommerce
					const name = firstAvailableRadio.attr('name');
					const value = firstAvailableRadio.val();
					$(`select[name="${name}"]`).val(value).trigger('change');

					// Add visual selection
					firstAvailableRadio
						.closest('.variation-radio-item')
						.addClass('selected-variation');
				}
			} else {
				// Ensure pre-selected items are properly synced
				alreadySelected.each(function () {
					const $radio = $(this);
					const name = $radio.attr('name');
					const value = $radio.val();

					// Sync select dropdown and notify WooCommerce
					$(`select[name="${name}"]`).val(value).trigger('change');

					// Add visual class
					$radio
						.closest('.variation-radio-item')
						.addClass('selected-variation');
				});
			}
		});
	}

	/**
	 * Attempt to initialize variations with retry logic
	 */
	let initializationComplete = false;

	function attemptInitialization() {
		if (initializationComplete) return true;

		if ($('.variations_form').length && $('.variation-radios').length) {
			initializeVariationSelections();
			initializationComplete = true;
			return true;
		}
		return false;
	}

	// Initialize with staggered timing for reliability
	setTimeout(() => attemptInitialization(), 100);
	setTimeout(() => {
		if (!initializationComplete) {
			attemptInitialization();
		}
	}, 300);
	setTimeout(() => {
		if (!initializationComplete) {
			attemptInitialization();
		}
	}, 800);
})(jQuery);
